import React, { useContext } from 'react';

import Head from 'react-helmet';

import { RMWContext } from '../../providers/RMWContext';
import stringHelper from '../../utils/stringHelper';
import StringConstants from '../../constants/StringConstants';

import { AppSelectors, RoutingSelectors } from '../../selectors';
import { useSelector } from '../../selectors/useSelector';

export type Props = {
  description?: string;
  noFollow?: boolean;
  noIndex?: boolean;
  title?: string;
  useStrictTitle?: boolean;
};

const HeadWrapper = ({
  description: customDescription = '',
  noFollow = false,
  noIndex = false,
  title: pTitle = '',
  useStrictTitle = false,
}: Props) => {
  const hostname = useSelector((state) => AppSelectors.makeHostname(state));
  const location = useSelector((state) => RoutingSelectors.makeLocation(state));
  const { brand } = useContext(RMWContext) as { brand: keyof typeof StringConstants.FORMATTED_BRAND_NAMES_RENTAL };
  const displayBrand = StringConstants.FORMATTED_BRAND_NAMES_RENTAL[brand];
  const defaultDescription =
    `Use ${displayBrand} to manage applications, screen tenants, ` +
    'collect rent and list your rental property on Zillow, Trulia and HotPads.';
  // Grabs custom meta description, if present OR grabs default description provided above
  const content = customDescription || defaultDescription;

  const title = useStrictTitle ? pTitle : stringHelper.getPageTitle(pTitle, brand);

  const link = [];

  // default meta data
  const meta = [
    {
      name: 'description',
      content,
    },
  ];

  // remove any query params (? and &)
  const href = `${hostname}${location.pathname}`.split('?')[0].split('&')[0];

  const getRobotMetaContent = () => {
    const robotContentList = [];

    if (noIndex) {
      robotContentList.push('noindex');
    }

    if (noFollow) {
      robotContentList.push('nofollow');
    }

    return robotContentList.join(', ');
  };

  // set canonical link
  link.push({
    rel: 'canonical',
    href,
  });

  meta.push({
    name: 'robots',
    content: getRobotMetaContent(),
  });

  return <Head meta={meta} title={title} link={link} />;
};

export default HeadWrapper;
